import $ from 'jquery';
import {
  NOVITA_DISMISSED_STORAGE_KEY,
  NOVITA_SURFACE_CANVAS_NAVBAR,
  NOVITA_SURFACE_OVERLAY,
  NOVITA_SURFACE_PRIVATE_NAVBAR,
} from './config';
import {
  buildNovitaItemEmbedUrl,
  buildNovitaListEmbedUrl,
} from './embedTracking';
import {
  buildNovitaUnreadSummaryLabel,
  emptyNovitaUnreadState,
  formatNovitaUnreadCount,
} from './state';
import { openNovitaEmbedModal } from './modal';

let currentState = emptyNovitaUnreadState();
let currentSessionKey = null;

const storageKey = () =>
  currentSessionKey
    ? `${currentSessionKey}.${NOVITA_DISMISSED_STORAGE_KEY}`
    : NOVITA_DISMISSED_STORAGE_KEY;

const getDismissedId = () => {
  try {
    return localStorage.getItem(storageKey());
  } catch {
    return null;
  }
};

const setDismissedId = (id) => {
  try {
    if (id) {
      localStorage.setItem(storageKey(), id);
    } else {
      localStorage.removeItem(storageKey());
    }
  } catch {
    // localStorage non disponibile: lo stato resta nel DOM.
  }
};

const hideNovitaUnreadOverlay = () => {
  $('#novita-unread-overlay')
    .removeClass('is-visible')
    .removeAttr('data-novita-current-id');
};

const updateNovitaLauncherUI = (count) => {
  const unreadCount = Number(count) || 0;
  const $launchers = $('[data-novita-launcher]');
  const $counts = $('[data-novita-launcher-count]');

  if (unreadCount > 0) {
    $counts
      .text(formatNovitaUnreadCount(unreadCount))
      .removeClass('d-none')
      .attr('aria-label', `${unreadCount} novità non lette`);
    $launchers.addClass('novita-launcher--has-unread');
    return;
  }

  $counts.addClass('d-none').text('').removeAttr('aria-label');
  $launchers.removeClass('novita-launcher--has-unread');
};

const updateNovitaUnreadOverlay = (state) => {
  const unreadCount = Number(state?.unreadCount) || 0;
  const preview = state?.previewItem || null;
  const $overlay = $('#novita-unread-overlay');

  if (
    unreadCount <= 0 ||
    !preview ||
    !preview.id ||
    !preview.title ||
    getDismissedId() === preview.id
  ) {
    hideNovitaUnreadOverlay();
    return;
  }

  $overlay.attr('data-novita-current-id', preview.id);
  $overlay
    .find('[data-novita-banner-open]')
    .attr('aria-label', `Apri novità ${preview.title}`)
    .attr(
      'data-novita-embed-url',
      preview.embedUrl || buildNovitaItemEmbedUrl(preview.url) || ''
    );
  $overlay.find('[data-novita-banner-label]').text(preview.label || 'Novità');
  $overlay
    .find('[data-novita-banner-count]')
    .text(formatNovitaUnreadCount(unreadCount));
  $overlay.find('[data-novita-banner-title]').text(preview.title);
  $overlay
    .find('[data-novita-banner-summary]')
    .text(buildNovitaUnreadSummaryLabel(unreadCount));

  const $cover = $overlay.find('[data-novita-banner-cover]');
  if (preview.cover) {
    $cover.attr('src', preview.cover);
  } else {
    $cover.removeAttr('src');
  }

  $overlay.addClass('is-visible');
};

export const updateNovitaSessionKey = (sessionKey) => {
  currentSessionKey = sessionKey;
};

export const updateNovitaStateUI = (state) => {
  currentState = state || emptyNovitaUnreadState();
  updateNovitaLauncherUI(currentState.unreadCount);
  updateNovitaUnreadOverlay(currentState);
};

const openLauncher = (surface) => {
  openNovitaEmbedModal(
    surface,
    buildNovitaListEmbedUrl(currentState.unreadItemIds)
  );
};

export const bindNovitaUIEvents = () => {
  $('body')
    .off('click.novita', '[data-novita-launcher]')
    .on('click.novita', '[data-novita-launcher]', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openLauncher(
        $(this).data('novitaSurface') || NOVITA_SURFACE_PRIVATE_NAVBAR
      );
    });

  $('body')
    .off('click.novita', '[data-novita-banner-open]')
    .on('click.novita', '[data-novita-banner-open]', function (event) {
      event.preventDefault();
      event.stopPropagation();
      openNovitaEmbedModal(
        $(this).data('novitaSurface') || NOVITA_SURFACE_OVERLAY,
        $(this).attr('data-novita-embed-url') || null
      );
    });

  $('body')
    .off('click.novita', '[data-novita-banner-dismiss]')
    .on('click.novita', '[data-novita-banner-dismiss]', function (event) {
      event.preventDefault();
      event.stopPropagation();
      const currentId = $('#novita-unread-overlay').attr(
        'data-novita-current-id'
      );
      if (currentId) setDismissedId(currentId);
      hideNovitaUnreadOverlay();
    });
};

export { NOVITA_SURFACE_CANVAS_NAVBAR, NOVITA_SURFACE_PRIVATE_NAVBAR };
